import get from 'lodash.get';
import getIsB2C from './is-b2c';

const getMyyolaUrl = (rootState) => {
  if (getIsB2C(rootState)) {
    return get(rootState, 'config.service.common.myyola.url', null);
  }

  return get(rootState, 'config.service.common.myyola.wl_url', null);
};

export default getMyyolaUrl;
